import React from "react";

const About = () => {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h4
            style={{
              textDecoration: "underline",
              marginTop: "12px",
            }}
          >
            About Us
          </h4>
        </div>
        <div className="col-md-12">
          <div className="about-info">
            <p>
              "SARTHI INFOTECH" has been founded by Mr.Anil Kamaliya (Director)
              & Er. Kamlesh Chudasama(Director) with his long term vision to
              provinde All IT And Electrical Solutions (CCTV Security solution ,
              home atomation , House wiring , Bio-Matrix solution , EPABX\/IP
              PBX system, networking , Fire alarm system , Online UPS , Wireless
              Solution And Audio & video solution) with their strong &
              experience team having more then 3 yrs expertise in the field.
            </p>
          </div>
        </div>

        <div className="col-md-4 offset-md-8">
          <div className="about-address-info">
            <h4>Address</h4>
            <p className="p-2">
              Railway station Veraval , Near Rarsh Complex - 362265 <br />
              Mobile No: 9979076950,79841 42504 ,84603 38075 <br />
              Email Id:&nbsp;
              <a href="mailto:infosarthiinfoteck@gmail.com" target="blank">
                infosarthiinfoteck@gmail.com
              </a>
              <br /> Website:&nbsp;
              <a href="https://sarthiinfotech.netlify.app/" target="blank">
                https://sarthiinfotech.netlify.app
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
